import $ from 'jquery';
require('slick-carousel');

export default function () {

    function slickSlider() {
        const mediaSlides = $('.js-media-slider');

        mediaSlides.each(function() {

            const slide = $(this);
            var scrollCount = null;
            var scroll= null;

            slide.slick({
                arrows: true,
                fade: true,
                autoplay: false,
                infinite: true,
                appendArrows: $(this).siblings('.js-slider-arrows'),
                dots: true,
                dotsClass: 'media-grid__count',
                customPaging: function (slider, i) {
                    return (i + 1) + '/' + slider.slideCount;
                }
            });

            slide.on('wheel', (function(e) {
                e.preventDefault();

                clearTimeout(scroll);
                scroll = setTimeout(function(){scrollCount=0;}, 20);
                if(scrollCount) return 0;
                scrollCount=1;

                if (e.originalEvent.deltaY < 0) {
                    $(this).slick('slickNext');
                } else {
                    $(this).slick('slickPrev');
                }
            }));

        });
    }

    slickSlider();

}
